import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { SiaInitDirective, SiaTooltipDirective } from '@sia/shared';
import $ from 'jquery';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
@Component({
  selector: 'sia-slider-box',
  templateUrl: './sia-slider-box.component.html',
  styleUrls: ['./sia-slider-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.sia-slider-rating]': 'ratingSlider()',
  },
  imports: [
    MatLabel,
    MatSlider,
    SiaInitDirective,
    MatSliderThumb,
    FormsModule,
    SiaTooltipDirective,
  ],
})
export class SiaSliderComponent extends SiaBaseEditorSignalComponent {
  readonly minValue = input<number>(0);
  readonly maxValue = input<number>(100);
  readonly description = input<string>('');
  readonly ratingSlider = input(false);

  override value = model<number>(0);

  private _timeouts: any[] = [];

  constructor() {
    super();

    effect(() => {
      // react whenever the slider value, max range or rating mode changes
      this.value();
      this.maxValue();
      this.ratingSlider();
      this.setElementColor();
    });
  }

  handleValueChange(v: number) {
    const normalized = v ?? 0;
    if (normalized === this.value()) {
      return;
    }
    this.value.set(normalized);
  }

  async setElementColor() {
    const currentValue = this.value() ?? 0;
    const maxValue = this.maxValue();
    const isRatingSlider = this.ratingSlider();

    let t = setTimeout(async () => {
      var thumb = $(`.mdc-slider__thumb-knob`);
      if (!isRatingSlider || !thumb) {
        await Promise.resolve(() => {
          let t = setTimeout(() => {
            return;
          }, 200);
          this._timeouts.push(t);
        });
        this.setElementColor();
        return;
      }
      $(`.sia-slider-knob-label`).remove();
      thumb.prepend(
        `<span class="sia-slider-knob-label">${currentValue}</span>`,
      );
      if (!currentValue || currentValue < (33 / 100) * maxValue) {
        thumb.css('background', '#b94a48');
        thumb.css('color', '#fff');
      } else if (currentValue > (66 / 100) * maxValue) {
        thumb.css('background', '#4bc67d');
        thumb.css('color', '#000');
      } else {
        thumb.css('background', '#f1c40f');
        thumb.css('color', '#000');
      }
    });
    this._timeouts.push(t);
  }

  ngOnDestroy(): void {
    this._timeouts?.forEach((t) => {
      clearTimeout(t);
    });
    this._timeouts = [];
  }
}
